import { httpRequest, httpRequest_002 } from "./Axios";
import { httpRequest_001 } from "./Axios";
// export const GET_API_LOGIN = (userId, password) => {
//   return {
//     method: "POST",
//     url: `General/Login`,
//     data: {
//       userId,
//       password,
//     },
//   };
// };
// export const GET_API_DESKECOM_KERNCA_GETROW = (vRdxFilter, vRdxUser, apiObj) => {
//   return {
//     method: "POST",
//     url: `Order/DeskecomKernCA`
//   };
// };

export const GET_API_LOGIN = (userId, password) => {
  return {
    method: "POST",
    url: `General/Login`,
    data: {
      userId,
      password,
    },
  };
};
export const KERN_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Wms/Kern`,
  };
};
export const TAX_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Wms/Tax`,
  };
};
export const WMSSI_TYPES = (apiObj) => {
  return {
    method: "GET",
    // url: `/WmsSI/GetWmsSITypes`
    url: `/WmsSI/getTypes`,
  };
};
export const GET_API_WTAG_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Tag/Tags`,
  };
};
export const RpDesign_getGitterColumns_GETROW = (apiObj) => {
  return {
    method: "GET",
    url: `/RpDesign/getGitterColumns?trnTyp=${apiObj}`,
  };
};
export const GET_API_DOC_LOADING = (apiObj) => {
  return {
    method: "POST",
    url: `/Wms/DocLoading`,
    data: apiObj,
  };
};

export const GET_API_DOC_TYPE = (apiObj) => {
  return {
    method: "POST",
    url: `/Wms/DocRights`,
    data: apiObj,
  };
};
export const GET_API_UNLOADING_BAY = (apiObj) => {
  return {
    method: "POST",
    url: `/Wms/UnloadingBay`,
    data: apiObj,
  };
};
export const GET_API_CURRENCY = (apiObj) => {
  return {
    method: "POST",
    url: `/Wms/Currency`,
    data: apiObj,
  };
};
export const SUBKONTEN_SEARCH_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Wms/SubKontenSearch`,
    data: {
      AnyData: apiObj.AnyData,
      Code: apiObj.Code,
      Name: apiObj.Name,
      Parent: apiObj.Parent,
    },
  };
};

//old grn
export const LOCATION_SEARCH_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Wms/LocationSearch`,
    data: {
      v_AnyData: apiObj.AnyData,
      v_Cd: apiObj.Code,
      v_Distri: apiObj.Distri,
      v_Name: apiObj.Name,
      v_UserCd: apiObj.UserCd,
    },
  };
};
export const REFDOC_SEARCH_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Wms/RefDocSearch`,
    data: {
      v_RefDocTyp: apiObj.AnyData,
      v_Parent: apiObj.RefDocParent,
    },
  };
};

//old GRN
export const REFDOC_INV02RCVNGSC_SEARCH_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Wms/Inv02rcvngschSearch`,
    data: {
      v_RefDocNo: apiObj.AnyData ? apiObj.AnyData : "",
      v_InvoiceNo: apiObj.Code,
      v_GrnDocNo: apiObj.Name,
    },
  };
};

export const BIN_TRANSFER_REASON_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/BinTransfer/Reason`,
  };
};
export const WMBIN_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/BinTransfer/WMBin`,
  };
};
export const REF_INBOUND_SEARCH_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Wms/InboundSearch`,
    data: {
      // v_RefDocTyp:apiObj.AnyData,
      // v_Parent:"PO01"
      v_RefDocTyp: apiObj.AnyData,
      v_Parent: apiObj.RefType,
    },
  };
};
//old ItemSearch
export const ITEMSEARCH_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Wms/ItemsSearchGetRow`,
    data: {
      v_AnyData: apiObj.AnyData,
      v_ItmCd: apiObj.Code,
      v_ItmName: apiObj.Name,
      v_Barcode: apiObj.Barcode,
      v_ModelSelectedValue: apiObj.GroupCode,
      v_RefNo1: apiObj.RefNo,
      v_NameFc: apiObj.NameFL,
      v_CostPr: apiObj.CostPrice,
      v_RSP: apiObj.RSP,
      v_Catalogue: apiObj.Catalogue,
      v_Br: apiObj.Br,
      v_RefNo3: apiObj.RefNo3,
      v_Loc: apiObj.Loc,
      v_Vendor: apiObj.Vendor,
      // v_Vendor: ""
    },
  };
};

export const LOCATIONGROUP_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Wms/LocationGroup`,
  };
};
export const SUPPLIER_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Wms/Suppliers`,
    data: {
      v_Typ: apiObj,
    },
  };
};
export const ITEM_LINE_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Wms/ItemLine`,
    data: apiObj,
  };
};
export const ITEM_UNIT_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Wms/ItemUnitInstancePicking`,
    data: {
      v_ItemCd: apiObj,
    },
  };
};
export const ITEM_UNIT_INSTANTPICKING_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Wms/ItemUnitInstancePicking`,
    data: {
      v_ItemCd: apiObj,
    },
  };
};

export const SEARCHEXACTITEM_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/searchExactItem`,
    data: apiObj,
  };
};
export const SEARCHEXACTITEM_GETROW001 = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/Items_Search_GetRow_Full_WB_PLU`,
    data: apiObj,
  };
};
export const SEARCHITEM_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/searchItems`,
    data: apiObj,
  };
};
export const SEARCHITEM001_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/searchItems001`,
    data: apiObj,
  };
};
export const INBOUNDUNITRATE_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/InboundUnitRate`,
    data: apiObj,
  };
};
export const Inbound_Unit_Rate_GRN = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/Inbound_Unit_Rate_GRN`,
    data: apiObj,
  };
};
export const PARTYSEARCH001_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/partysearch`,
    data: apiObj,
  };
};
export const SEARCHVENDORITEM_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/searchVendorItems`,
    data: apiObj,
  };
};
export const UNITRATE_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/getUnitRate`,
    data: apiObj,
  };
};
export const GETITEMUNITS_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/getItemUnits`,
    data: apiObj,
  };
};
export const GETITEMUNITSINBOUND_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/getItemUnitsInbound`,
    data: apiObj,
  };
};
export const INVTRANS_ALIAS_GETROW_001 = (apiObj) => {
  return {
    method: "POST",
    url: `/Wms/InvtransAlias`,
    data: apiObj,
  };
};
export const UNIT_RATE_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Wms/UnitRate`,
    data: apiObj,
  };
};

/// Farooq Work

export const LOCATION = (userId) => {
  return {
    method: "POST",
    url: `/Picking/Location`,
    data: {
      v_UserCode: userId,
    },
  };
};

export const INSTANCE_PICKING_SR_NO = (apiObj) => {
  return {
    method: "POST",
    url: `/Picking/InstancePickingSrNo`,
    data: {
      v_VocCode: apiObj.VocType,
      v_VocNo: apiObj.VocNo,
    },
  };
};

//farook

export const BIN_TRANSFER_LIST = (apiObj) => {
  return {
    method: "POST",
    url: `/BinTransfer/SummaryList`,
    data: {
      v_Loc: apiObj.loc,
      v_Date1: apiObj.dateFrom,
      v_Date2: apiObj.dateTo,
      v_Status: apiObj.statusVal,
      v_UserCd: apiObj.v_UserCd,
      v_VocNo: apiObj.v_VocNo,
    },
  };
};

export const BIN_TRANSFER_REASON = () => {
  return {
    method: "POST",
    url: `/BinTransfer/Reason`,
    // data: null
  };
};

export const BIN_TRANSFER_HeadUPDATE = (apiObj) => {
  return {
    method: "POST",
    url: `/BinTransfer/HeadUpdate`,
    data: {
      v_A_VocTyp: apiObj.DocType,
      v_A_VocNo: apiObj.DocNo,
      v_A_VocDt: apiObj.Date,
      v_A_Loc: apiObj.LocCode,
      v_A_Reason: apiObj.Reason,
      v_A_Narr: apiObj.Narration,
      v_UserCd: apiObj.UserCd,
      v_IP: apiObj.IP,
      v_A_Type: apiObj.Type,
    },
  };
};

export const BIN_TRANSFER_CARD_ID = (apiObj) => {
  return {
    method: "POST",
    url: `/BinTransfer/CardIDDetails`,
    data: apiObj,
  };
};
export const BIN_TRANSFER_BARCODE_DETAILS = (apiObj) => {
  return {
    method: "POST",
    url: `/BinTransfer/BarcodeDetails`,
    data: apiObj,
  };
};
export const BIN_MULTI_BARCODE_DETAILS = (apiObj) => {
  return {
    method: "POST",
    url: `/BinTransfer/BarcodeCardIdLines`,
    data: apiObj,
  };
};
export const BIN_MULTI_BARCODE_DETAILS_CycleCount = (apiObj) => {
  return {
    method: "POST",
    url: `/physicalstock/BarcodeCardIdLinesCycleCount`,
    data: apiObj,
  };
};
export const PHYSICALSTOCK_BARCODE_DETAILS = (apiObj) => {
  return {
    method: "POST",
    url: `/physicalstock/BarcodeDetails`,
    data: apiObj,
  };
};

export const GET_API_BIN_STOCK = (apiObj) => {
  return {
    method: "POST",
    url: `/BinTransfer/BinStock`,
    data: apiObj,
  };
};

export const GET_API_BIN_STOCK_TRANSOUT = (apiObj) => {
  return {
    method: "POST",
    url: `/BinTransfer/BinStockTransOut`,
    data: apiObj,
  };
};
export const GET_API_BIN_TRANSFER_OUT_LINEITEM = (apiObj) => {
  return {
    method: "POST",
    url: `/BinTransfer/BinTransferOutLineItems`,
    data: apiObj,
  };
};
export const GET_API_BIN_TRANSFER_IN_LINEITEM = (apiObj) => {
  return {
    method: "POST",
    url: `/BinTransfer/BinTransferINLineItems`,
    data: apiObj,
  };
};
export const GET_API_BIN_TRANSFER_LINEITEM = (apiObj) => {
  return {
    method: "POST",
    url: `/BinTransfer/BinTransferLineItems`,
    data: apiObj,
  };
};
export const GET_API_BIN_TRANSFER_OUT_DELETE = (apiObj) => {
  return {
    method: "POST",
    url: `/BinTransfer/BinTransferOutDelete`,
    data: apiObj,
  };
};
export const GET_API_BIN_TRANSFER_IN_DELETE = (apiObj) => {
  return {
    method: "POST",
    url: `/BinTransfer/BinTransferINDelete`,
    data: apiObj,
  };
};
export const GET_API_BIN_TRANSFER_DELETE = (apiObj) => {
  return {
    method: "POST",
    url: `/BinTransfer/BinTransferDelete`,
    data: apiObj,
  };
};

export const GET_API_TRANS_OUT_SRNO = (apiObj) => {
  return {
    method: "POST",
    url: `/BinTransfer/TransOutSrNo`,
    data: apiObj,
  };
};
export const GET_API_TRANS_IN_SRNO = (apiObj) => {
  return {
    method: "POST",
    url: `/BinTransfer/TransInSrNo`,
    data: apiObj,
  };
};
export const GET_API_BIN_TRANSFER_OUTUPDATE = (apiObj) => {
  return {
    method: "POST",
    url: `/BinTransfer/BinTransferOutUpdate`,
    data: apiObj,
  };
};
export const GET_API_BIN_TRANSFER_DETAIL_UPDATE = (apiObj) => {
  return {
    method: "POST",
    url: `/BinTransfer/BinTransferDetailUpdate`,
    data: apiObj,
  };
};
export const GET_API_BIN_TRANSFER_INUPDATE = (apiObj) => {
  return {
    method: "POST",
    url: `/BinTransfer/BinTransferINUpdate`,
    data: apiObj,
  };
};
export const GET_API_BIN_TRANSFER_DETAILCOUNT = (apiObj) => {
  return {
    method: "POST",
    url: `/BinTransfer/BinTransDetailCount`,
    data: apiObj,
  };
};
export const GET_API_BIN_TRANSFER_POSTING = (apiObj) => {
  return {
    method: "POST",
    url: `/BinTransfer/BinTransferPosting`,
    data: apiObj,
  };
};
export const GET_API_READ_PARAMETER = (apiObj) => {
  return {
    method: "POST",
    url: `/BinTransfer/ReadParameter`,
    data: apiObj,
  };
};
// SAFIA
export const INSTANCE_PICKING_BARCODE_ITEM_SEARCH_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Picking/Wminv08pkdItemSearch`,
    data: apiObj,
  };
};
export const INSTANCE_PICKING_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Picking/InstancePicking`,
    data: apiObj,
  };
};
export const INSTANCE_PICKING_PKD_UPDATE_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Picking/PKDUpdate`,
    data: apiObj,
  };
};
export const INSTANCE_PICKING_DELETE_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Picking/WMINV08PKDDelete`,
    data: apiObj,
  };
};
export const INSTANCE_PICKING_DETAIL_LIST_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Picking/WMINV08PKDGetRow`,
    data: apiObj,
  };
};
export const INSTANCE_PICKING_POST_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Picking/InstancePickingPost`,
    data: apiObj,
  };
};
export const INSTANCE_PICKING_POST_VARIANCE_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Picking/InstancePickingPostVariance`,
    data: apiObj,
  };
};
export const INCENTIVEGROUP_GETROW = (apiObj) => {
  return {
    method: "GET",
    url:
      `/WmsSI/getIncentiveGroups?itemCd=` +
      apiObj.itemCd +
      `&loc=` +
      apiObj.loc,
  };
};
export const SUPERVISORSLABS_GETROW = (apiObj) => {
  return {
    method: "GET",
    url: `/WmsSI/getSupervisorSlabs`,
  };
};
export const OTHERSLABS_GETROW = (apiObj) => {
  return {
    method: "GET",
    url: `/WmsSI/getOtherSlabs`,
  };
};
export const SALESGROUPS_GETROW = (apiObj) => {
  return {
    method: "GET",
    url: `/WmsSI/getSalesGroups?loc=` + apiObj,
  };
};
export const SALESGROUPSSEARCH_GETROW = (apiObj) => {
  return {
    method: "GET",
    url: `/WmsSI/getSalesGroupsSearch?loc=` + apiObj,
  };
};

export const SALESMAN_GETROW = (apiObj) => {
  return {
    method: "GET",
    url: `/RpDesign/getSalesman`,
  };
};

export const SAVESIHEAD_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsSI/saveSIHead`,
    data: apiObj,
  };
};
export const SAVESIDETAIL_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsSI/saveSIDetail`,
    data: apiObj,
  };
};
export const GETSIHEAD_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsSI/getSIHead`,
    data: apiObj,
  };
};
export const GETSIDETAILS_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsSI/getSIDetails`,
    data: apiObj,
  };
};
export const SEARCHSIHEAD_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsSI/searchSIHead`,
    data: apiObj,
  };
};
export const DELETESIHEAD_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsSI/deleteSIHead`,
    data: apiObj,
  };
};
export const DELETESIDETAIL_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsSI/deleteSIDetail`,
    data: apiObj,
  };
};
export const TRANSPARTY_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/getTransParty`,
    data: apiObj,
  };
};
export const SIUSERDOCS_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsSI/getSIUserDocs`,
    data: apiObj,
  };
};
export const APPLYTDISCOUNT_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsSI/applyTDiscount`,
    data: apiObj,
  };
};
export const VALIDATIONHEADINFO_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/validateHeadInfo`,
    data: apiObj,
  };
};
export const VALIDATIONDETAILINFO_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/validateDetailInfo`,
    data: apiObj,
  };
};
export const CHECKDUEDATE_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/checkMonthDueDate`,
    data: apiObj,
  };
};
export const GETITEMATTRIBUTES_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/getItemAttributes`,
    data: apiObj,
  };
};
export const Lineitemsattributes_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/inv05/lineitemsattributes`,
    data: apiObj,
  };
};

export const GetItemAttributesPurchase_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/getItemAttributespurchase`,
    data: apiObj,
  };
};
export const GetDemandItemQty_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsSI/demanditemqtyvalidation`,
    data: apiObj,
  };
};
export const PoQtyValidation_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/poqtyvalidation`,
    data: apiObj,
  };
};
export const SalesReturnLineItemValidation = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSInbound/ValidateSalesReturnLineItem`,
    data: apiObj,
  };
};
export const TsrQtyValidation_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/tsrqtyvalidation`,
    data: apiObj,
  };
};
export const GrnRefNoValidation_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/grnRefnovalidation`,
    data: apiObj,
  };
};
export const DEFAULTDRCRACCOUNT_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/defaultDrCrAccount`,
    data: apiObj,
  };
};

export const USERRIGHTS_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/userRights`,
    data: apiObj,
  };
};
export const DOCRIGHTS_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/docRights`,
    data: apiObj,
  };
};
export const Checkbox_User_Rights_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSInbound/userRights`,
    data: apiObj,
  };
};
export const WMINV03D_GetRow = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSInbound/WMINV03D_GetRow`,
    data: apiObj,
  };
};
export const TransTaxType_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/TransTaxType`,
    data: apiObj,
  };
};
export const AccountTransSearch_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/AccountTransSearch`,
    data: apiObj,
  };
};
export const DefaultValue_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/DefaultValues`,
    data: apiObj,
  };
};

export const CHECKCUSTOMEROVERDUE_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/checkCutomerOverdue`,
    data: apiObj,
  };
};
export const CHECKCRLIMIT_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/checkCRLimit`,
    data: apiObj,
  };
};
export const ITEMNARRATION_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/itemNarration`,
    data: apiObj,
  };
};
export const REVERSETRANSACTION_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/reverseTransaction`,
    data: apiObj,
  };
};
export const DISPATCHSUMMARY_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/wmsDispatch/dispatchSummary`,
    data: apiObj,
  };
};
export const DISPATCH_GETITEMS_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/wmsDispatch/getItems`,
    data: apiObj,
  };
};
export const DISPATCH_DELETE_ITEMS_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `wmsDispatch/deleteItem`,
    data: apiObj,
  };
};
export const DISPATCH_SAVE_ITEMS_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/wmsDispatch/saveItem`,
    data: apiObj,
  };
};
export const DISPATCH_VARIANCE_ITEMS_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/wmsDispatch/variance`,
    data: apiObj,
  };
};
export const DISPATCH_POSTDISPATCH_ITEMS_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/wmsDispatch/postDispatch`,
    data: apiObj,
  };
};
export const WMSSI_ITEMSTOCK_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsSI/ItemStockUOM`,
    data: apiObj,
  };
};
export const AUDITFIELD_GETROW = (apiObj) => {
  return {
    method: "GET",
    url: `/RpDesign/auditFields?trnTyp=` + apiObj,
  };
};
export const TRANSAUDIT_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/transAudit`,
    data: apiObj,
  };
};
export const SALESHISTORY_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsSI/salesHistory`,
    data: apiObj,
  };
};
export const WMTransSalesGroupDetail_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsSI/WMTransSalesGroupDetail`,
    data: apiObj,
  };
};
export const WMTransSalesGroupUpdate_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsSI/WMTransSalesGroupUpdate`,
    data: apiObj,
  };
};
export const defcustomersetting_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsSI/defcustomersetting`,
    data: apiObj,
  };
};

export const FillVanMaster_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsSI/fillVanMaster`,
    data: apiObj,
  };
};
export const WMINV08VANMastItemList_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsSI/WMINV08VANMastItemList`,
    data: apiObj,
  };
};
export const WMINV08_wmsErpStockDetail_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsSI/wmsErpStockDetail`,
    data: apiObj,
  };
};
export const WMINV08VANMastItemDelete_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsSI/WMINV08VANMastItemDelete`,
    data: apiObj,
  };
};
export const WMINV08VANMastItemSave_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsSI/WMINV08VANMastItemSave`,
    data: apiObj,
  };
};

export const EmployeeSearchVanGroup_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsSI/EmployeeSearchVanGroup`,
    data: apiObj,
  };
};

export const WMINV10_saveHead_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSStockTransfer/saveHead`,
    data: apiObj,
  };
};
export const WMINV10_fDisplay_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSStockTransfer/fDisplay`,
    data: apiObj,
  };
};
export const WMINV10_deleteHead_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSStockTransfer/deleteHead`,
    data: apiObj,
  };
};
export const WMINV10_saveDetail_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSStockTransfer/saveDetail`,
    data: apiObj,
  };
};
export const WMINV10_deleteDetails_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSStockTransfer/deleteDetails`,
    data: apiObj,
  };
};
export const WMINV10_GridLoad_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSStockTransfer/GridLoad`,
    data: apiObj,
  };
};
export const WMINV10_userDoc_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSStockTransfer/userDoc`,
    data: apiObj,
  };
};
export const WMINV10_Search_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSStockTransfer/Search`,
    data: apiObj,
  };
};
export const WMINV10_SearchLocation_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSStockTransfer/SearchLocation`,
    data: apiObj,
  };
};
export const WMINV10_Location_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSStockTransfer/Location`,
    data: apiObj,
  };
};
export const WMINV10_Party_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSStockTransfer/Party`,
    data: apiObj,
  };
};
export const WMINV10_itemUnit_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSStockTransfer/itemUnit`,
    data: apiObj,
  };
};
export const WMINV10_UnitRate_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSStockTransfer/UnitRate`,
    data: apiObj,
  };
};
export const WMINV10_getItemAttributesPurchaseReturn_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSStockTransfer/getItemAttributes`, //by sir getItemAttributesPurchaseReturn-->getItemAttributes
    data: apiObj,
  };
};
export const WMINV10_validatecostvariance_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSStockTransfer/validatecostvariance`,
    data: apiObj,
  };
};
export const WMINV10_validateDetail_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSStockTransfer/validateDetail`,
    data: apiObj,
  };
};
export const WMINV10_validateHead_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSStockTransfer/validateHead`,
    data: apiObj,
  };
};
export const WMINV10_reverseTransaction_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSStockTransfer/reverseTransaction`,
    data: apiObj,
  };
};

export const LOADING_SUMMARY_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSloading/LoadingSummary`,
    data: apiObj,
  };
};
export const EASY_LOADING_SUMMARY_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSloading/EasyLoadingSummary`,
    data: apiObj,
  };
};
export const LOADING_ITEMSEARCH_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSloading/LoadingItemSearch`,
    data: apiObj,
  };
};
export const LOADING_VARIANCE_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSloading/LoadingVariance`,
    data: apiObj,
  };
};
export const LOADING_VARIANCE_LDList_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSloading/LoadingVarianceAndLDList`,
    data: apiObj,
  };
};
export const LOADING_ITEMLIST_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSloading/LoadingItemList`,
    data: apiObj,
  };
};
export const LOADING_ITEMDELETE_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSloading/LoadingItemDelete`,
    data: apiObj,
  };
};
export const LOADING_ITEMSAVE_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSloading/LoadingItemSave`,
    data: apiObj,
  };
};
export const LOADING_ITEMPOST_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSloading/LoadingPost`,
    data: apiObj,
  };
};

//Notification
export const NOTIFICATION_SUMMARY_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Picking/PickingSummary`,
    data: apiObj,
  };
};
export const NOTIFICATION_PICKINGHEAD_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Picking/PickingHead`,
    data: apiObj,
  };
};
export const NOTIFICATION_PICKINGAISLELIST_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Picking/PickingAisleList`,
    data: apiObj,
  };
};
export const NOTIFICATION_PICKINGLEVELLIST_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Picking/PickingLevelList`,
    data: apiObj,
  };
};
export const NOTIFICATION_PICKINGPENDINGITEMS_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Picking/PickingPendingItems`,
    data: apiObj,
  };
};
export const NOTIFICATION_PICKINGSAVING_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Picking/PickingSaving`,
    data: apiObj,
  };
};
export const NOTIFICATION_PICKINGPOSTING_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Picking/PickingPosting`,
    data: apiObj,
  };
};
export const NOTIFICATION_PICKINGVARIANCE_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Picking/PickingVariance`,
    data: apiObj,
  };
};
export const NOTIFICATION_PICKINGCARDIDSEARCH_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Picking/CardIdSearch`,
    data: apiObj,
  };
};

export const NOTIFICATION_PICKINGLINEDETAIL_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Picking/PickingLineDetail`,
    data: apiObj,
  };
};
export const BIN_ENQUIRY_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Picking/BinEnquiry`,
    data: apiObj,
  };
};
//new grn api
export const GRN_INV02RCVNGSCSEARCH_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Wms/Inv02rcvngschSearch`,
    data: apiObj,
  };
};
export const GRN_RefSearchSearch_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Wms/RefSearchSearch`,
    data: apiObj,
  };
};

export const GRN_LOCATIONSEARCH_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Wms/LocationSearch`,
    data: apiObj,
  };
};
export const GRN_ITEMSEARCH_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Wms/ItemsSearchGetRow`,
    data: apiObj,
  };
};
export const ITEM_SEARCHFULL_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/Wms/ItemSearchFullSearch`,
    data: apiObj,
  };
};
export const BranchList_GETROW = (apiObj) => {
  return {
    method: "GET",
    url: `/RpDesign/BranchList`,
    data: apiObj,
  };
};
export const LocationItemSearch_GETROW = (apiObj) => {
  return {
    method: "GET",
    url: `/RpDesign/LocationItemList?Loc=` + apiObj,
    data: apiObj,
  };
};
export const CustomerListSearch_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsSI/CustomerList`,
    data: apiObj,
  };
};
export const ItemsAliasList_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsSI/ItemsAliasList`,
    data: apiObj,
  };
};
export const GRN_USER_DOC_GETROW_001 = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSInbound/getUserDocs`,
    data: apiObj,
  };
};
export const GRN_SAVE_HEAD_GETROW_001 = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSInbound/saveHead`,
    data: apiObj,
  };
};
export const GRN_SAVE_DETAIL_GETROW_001 = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSInbound/saveDetail`,
    data: apiObj,
  };
};
export const GRN_GET_HEAD_GETROW_001 = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSInbound/getHead`,
    data: apiObj,
  };
};
export const GRN_GET_DETAIL_GETROW_001 = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSInbound/getDetails`,
    data: apiObj,
  };
};
export const GRN_DELETE_HEAD_GETROW_001 = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSInbound/deleteHead`,
    data: apiObj,
  };
};
export const GRN_DELETE_DETAIL_GETROW_001 = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSInbound/deleteDetail`,
    data: apiObj,
  };
};
export const SAVE_DETAIL_BATCH_GETROW_001 = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSInbound/saveDetailBatch`,
    data: apiObj,
  };
};

export const DELETE_DETAIL_BATCH_GETROW_001 = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSInbound/deleteDetailBatch`,
    data: apiObj,
  };
};

export const WMINV03VANMASTFill_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSInbound/WMINV03VANMASTFill`,
    data: apiObj,
  };
};

export const WMINV03VANMASTSave_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSInbound/WMINV03VANMASTSave`,
    data: apiObj,
  };
};

export const Inbound_applyTDiscount_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSInbound/applyTDiscount`,
    data: apiObj,
  };
};

export const FreightUpdate_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSInbound/FreightUpdate`,
    data: apiObj,
  };
};

export const WMINV03VANMASTDelete_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSInbound/WMINV03VANMASTDelete`,
    data: apiObj,
  };
};
export const WMINV03VANMASTDetail_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSInbound/WMINV03VANMASTDetail`,
    data: apiObj,
  };
};
export const searchHead_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSInbound/searchHead`,
    data: apiObj,
  };
};

export const VALIDATE_HEAD_WMINV03_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSInbound/validateHeadwminv03`,
    data: apiObj,
  };
};
export const CHECK_PO_CREDIT_NOTE_AMOUNT_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSInbound/checkPOCreditNoteAmount`,
    data: apiObj,
  };
};
export const VALIDATE_COST_VARIANCE_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSInbound/validatecostvariance`,
    data: apiObj,
  };
};
export const GET_BATCH_DETAILS_GETROW_001 = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSInbound/getBatchDetails`,
    data: apiObj,
  };
};
export const GET_getVirtualBinList_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSInbound/getVirtualBinList`,
    data: apiObj,
  };
};
export const GRN_BUYER_GETROW_001 = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/getBuyers`,
    data: apiObj,
  };
};
export const WMINV03_CostUpdate_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/CostUpdate`,
    data: apiObj,
  };
};
//WMINV04 outbound Grv
export const WMINV04_getTypes_GETROW = (apiObj) => {
  return {
    method: "GET",
    url: `/WMSGRV/getTypes`,
  };
};
export const WMINV04_saveHead_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSGRV/saveHead`,
    data: apiObj,
  };
};

export const WMINV04_saveDetail_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSGRV/saveDetail`,
    data: apiObj,
  };
};
export const WMINV04_getHead_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSGRV/getHead`,
    data: apiObj,
  };
};
export const WMINV04_getDetails_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSGRV/getDetails`,
    data: apiObj,
  };
};
export const WMINV04_search_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSGRV/search`,
    data: apiObj,
  };
};
export const WMINV04_deleteHead_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSGRV/deleteHead`,
    data: apiObj,
  };
};
export const WMINV04_deleteDetail_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSGRV/deleteDetail`,
    data: apiObj,
  };
};
export const WMINV04_getUserDocs_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSGRV/getUserDocs`,
    data: apiObj,
  };
};
export const WMINV04_applyTDiscount_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSGRV/applyTDiscount`,
    data: apiObj,
  };
};
export const WMINV04_itemStock_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSGRV/itemStock`,
    data: apiObj,
  };
};
export const WMINV04_salesHistory_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSGRV/salesHistory`,
    data: apiObj,
  };
};
export const WMINV04_validateHead_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSGRV/validateHead`,
    data: apiObj,
  };
};
export const WMINV04_validateDetail_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSGRV/validateDetail`,
    data: apiObj,
  };
};
export const WMINV04_getItemAttributesPurchaseReturn_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/getItemAttributesPurchaseReturn`,
    data: apiObj,
  };
};
export const WMINV04_reverseTransaction_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSGRV/reverseTransaction`,
    data: apiObj,
  };
};

//WMINV04 outbound Grv END
//LoadingList start
export const LoadingList_Cluster_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSloading/Cluster`,
    data: apiObj,
  };
};
export const LoadingList_Location_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSloading/Location`,
    data: apiObj,
  };
};
export const LoadingList_Transaction_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSloading/Transaction`,
    data: apiObj,
  };
};
export const LoadingList_LoadingPay_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSloading/LoadingPay`,
    data: apiObj,
  };
};
export const LoadingList_Truck_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSloading/Truck`,
    data: apiObj,
  };
};
export const LoadingList_LoadingType_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSloading/LoadingType`,
    data: apiObj,
  };
};
export const LoadingList_loadinglistcheckbox_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSloading/loadinglistcheckbox`,
    data: apiObj,
  };
};
export const LoadingList_GridLoad_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSloading/GridLoad`,
    data: apiObj,
  };
};
export const LoadingList_TransDetail_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSloading/TransDetail`,
    data: apiObj,
  };
};
export const LoadingList_FupdateHead_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSloading/FupdateHead`,
    data: apiObj,
  };
};
export const LoadingList_Release_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSloading/Release`,
    data: apiObj,
  };
};
export const LoadingList_getHead_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSloading/getHead`,
    data: apiObj,
  };
};
export const LoadingList_save_detail_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSloading/save_detail`,
    data: apiObj,
  };
};
export const LoadingList_deleteHead_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSloading/deleteHead`,
    data: apiObj,
  };
};
export const LoadingList_getUserDocs_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSloading/getUserDocs`,
    data: apiObj,
  };
};
export const LoadingList_Reverse_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSloading/Reverse`,
    data: apiObj,
  };
};
export const LoadingList_LoadingSearch_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSloading/LoadingSearch`,
    data: apiObj,
  };
};
//LoadingList end
//LoadingReceipt start
export const LoadingReceipt_Location_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/DOReceiving/Location`,
    data: apiObj,
  };
};
export const LoadingReceipt_LoadGrid_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/DOReceiving/LoadGrid`,
    data: apiObj,
  };
};
export const LoadingReceipt_SaveDetails_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/DOReceiving/SaveDetails`,
    data: apiObj,
  };
};
export const LoadingReceipt_DeleteDetails_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/DOReceiving/DeleteDetails`,
    data: apiObj,
  };
};
export const LoadingReceipt_fDisplay_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/DOReceiving/fDisplay`,
    data: apiObj,
  };
};
export const LoadingReceipt_Search_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/DOReceiving/Search`,
    data: apiObj,
  };
};
export const LoadingReceipt_UserDoc_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/DOReceiving/UserDoc`,
    data: apiObj,
  };
};
export const LoadingReceipt_Approve_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/DOReceiving/Approve`,
    data: apiObj,
  };
};
export const LoadingReceipt_DoStamping_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/DOReceiving/DoStampingStatus`,
    data: apiObj,
  };
};
export const LoadingReceipt_StampingUpdate_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/DOReceiving/StampingUpdate`,
    data: apiObj,
  };
};

//LoadingReceipt end
// Stock Adj start
export const WMINV11_history_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/stockAdjustment/history`,
    data: apiObj,
  };
};
export const WMINV11_UnitRate_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/stockAdjustment/UnitRate`,
    data: apiObj,
  };
};
export const WMINV11_reason_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/stockAdjustment/reason`,
    data: apiObj,
  };
};
export const WMINV11_adjustmentType_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/stockAdjustment/adjustmentType`,
    data: apiObj,
  };
};
export const WMINV11_location_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/stockAdjustment/location`,
    data: apiObj,
  };
};
export const WMINV11_saveHead_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/stockAdjustment/saveHead`,
    data: apiObj,
  };
};
export const WMINV11_saveDetail_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/stockAdjustment/saveDetail`,
    data: apiObj,
  };
};
export const WMINV11_deleteHead_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/stockAdjustment/deleteHead`,
    data: apiObj,
  };
};
export const WMINV11_deleteDetail_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/stockAdjustment/deleteDetail`,
    data: apiObj,
  };
};
export const WMINV11_fdisplay_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/stockAdjustment/fdisplay`,
    data: apiObj,
  };
};
export const WMINV11_search_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/stockAdjustment/search`,
    data: apiObj,
  };
};
export const WMINV11_gridLoad_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/stockAdjustment/gridLoad`,
    data: apiObj,
  };
};
export const WMINV11_userDoc_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/stockAdjustment/userDoc`,
    data: apiObj,
  };
};
export const WMINV11_currentStock_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/stockAdjustment/currentStock`,
    data: apiObj,
  };
};
export const WMINV11_validateHead_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/stockAdjustment/validateHead`,
    data: apiObj,
  };
};
export const WMINV11_validateDetail_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/stockAdjustment/validateDetail`,
    data: apiObj,
  };
};
export const WMINV11_getItemAttributes_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/stockAdjustment/getItemAttributes`,
    data: apiObj,
  };
};
// Stock Adj end

//PutAway start
export const PUTAWAY_getPutAwaySummary_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsPutaway/getPutAwaySummary`,
    data: apiObj,
  };
};
export const PUTAWAY_putAwayBiny_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsPutaway/putAwayBin`,
    data: apiObj,
  };
};
export const PUTAWAY_putAwayVariance_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsPutaway/putAwayVariance`,
    data: apiObj,
  };
};
export const PUTAWAY_getPutAwayHead_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsPutaway/getPutAwayHead`,
    data: apiObj,
  };
};
export const PUTAWAY_savePutAway_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsPutaway/savePutAway`,
    data: apiObj,
  };
};
export const PUTAWAY_deteteItem_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsPutaway/deteteItem`,
    data: apiObj,
  };
};
export const PUTAWAY_loadDetail_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsPutaway/loadDetail`,
    data: apiObj,
  };
};
export const PUTAWAY_checkPutawayCompleted_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsPutaway/checkPutawayCompleted`,
    data: apiObj,
  };
};
export const PUTAWAY_approvePutAway_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsPutaway/approvePutAway001`,
    data: apiObj,
  };
};
export const PUTAWAY_getCardDetail_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsPutaway/getCardDetail`,
    data: apiObj,
  };
};
export const PUTAWAY_putAwayBarcode_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsPutaway/putAwayBarcode`,
    data: apiObj,
  };
};
export const PUTAWAY_validateDetails_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsPutaway/validateDetails`,
    data: apiObj,
  };
};
export const PUTAWAY_validateDetails_GETROW_EasyPutaway = (apiObj) => {
  return {
    method: "POST",
    url: `/WmsPutaway/easyPutawayValidateDetails`,
    data: apiObj,
  };
};

//PutAway end
export const Common_transpartylist_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/common/transpartylist`,
    data: apiObj,
  };
};
export const Common_partyosamtt_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/common/partyosamt`,
    data: apiObj,
  };
};

//salesInvoice
export const INV08_savehead_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/salesInvoice/savehead`,
    data: apiObj,
  };
};
export const INV08_history_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/salesInvoice/history`,
    data: apiObj,
  };
};
export const INV08_saveDetail_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/salesInvoice/saveDetail`,
    data: apiObj,
  };
};
export const INV08_deleteHead_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/salesInvoice/deleteHead`,
    data: apiObj,
  };
};
export const INV08_deleteDetail_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/salesInvoice/deleteDetail`,
    data: apiObj,
  };
};
export const INV08_search_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/salesInvoice/search`,
    data: apiObj,
  };
};
export const INV08_audit_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/salesInvoice/audit`,
    data: apiObj,
  };
};
export const INV08_fDisplay_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/salesInvoice/fDisplay`,
    data: apiObj,
  };
};
export const INV08_loadGrid_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/salesInvoice/loadGrid`,
    data: apiObj,
  };
};
export const INV08_userDoc_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/salesInvoice/userDoc`,
    data: apiObj,
  };
};
//salesInvoiceEnd
//wmsPhysicalStock start

export const WMIPT01_gridLoad_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/physicalstock/gridLoad`,
    data: apiObj,
  };
};
export const WMIPT01_saveHead_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/physicalstock/saveHead`,
    data: apiObj,
  };
};
export const WMIPT01_saveDetail_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/physicalstock/saveDetail`,
    data: apiObj,
  };
};
export const WMIPT01_deleteHead_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/physicalstock/deleteHead`,
    data: apiObj,
  };
};
export const WMIPT01_deleteDetail_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/physicalstock/deleteDetail`,
    data: apiObj,
  };
};
export const WMIPT01_summary_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/physicalstock/summary`,
    data: apiObj,
  };
};
//wmsPhysicalStock end

//wmsPoPhysicalStock start

export const WMPOIPT01_poGridLoad_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/physicalstock/poGridLoad`,
    data: apiObj,
  };
};
export const WMPOIPT01_poSaveHead_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/physicalstock/poSaveHead`,
    data: apiObj,
  };
};
export const WMPOIPT01_poSaveDetail_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/physicalstock/poSaveDetail`,
    data: apiObj,
  };
};
export const WMPOIPT01_poDelete_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/physicalstock/poDelete`,
    data: apiObj,
  };
};

export const WMPOIPT01_poDisplay_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/physicalstock/poDisplay`,
    data: apiObj,
  };
};
export const WMPOIPT01_poSummary_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/physicalstock/poSummary`,
    data: apiObj,
  };
};
export const WMPOIPT01_poApprove_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/physicalstock/poApprove`,
    data: apiObj,
  };
};
export const WMPOIPT01_PoType_GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/physicalstock/PoType`,
  };
};
//wmsPoPhysicalStock end
export const Login_getUserMenus__GETROW = (apiObj) => {
  return {
    method: "POST",
    url: `/RpDesign/getUserMenus`,
    data: apiObj,
  };
};

export const Get_Quick_Sales_Category = () => {
  return {
    method: "POST",
    url: `/Quicksale/QuickSalesCategory`,
    // data: apiObj,
  };
};

export const Get_Quick_Sales_Items = (apiObj) => {
  return {
    method: "POST",
    url: `/Quicksale/QuickSalesItems`,
    data: apiObj,
  };
};

export const Quicksale_SaveINV06QS = (apiObj) => {
  return {
    method: "POST",
    url: `/Quicksale/SaveINV06QS`,
    data: apiObj,
  };
};

export const Quicksale_Get_Row_Api = (apiObj) => {
  return {
    method: "POST",
    url: `/Quicksale/GetINV06QSARow`,
    data: apiObj,
  };
};
export const Order_Picking_Update_Api = (apiObj) => {
  return {
    method: "POST",
    url: `/Quicksale/INV06QSA_Picking`,
    data: apiObj,
  };
};

export const Order_Cancel_Summary_Get_Row_Api = (apiObj) => {
  return {
    method: "POST",
    url: `/Quicksale/GetINV06QSAOrderSummaryPending`,
    data: apiObj,
  };
};

export const Order_Delivery_Update_Api = (apiObj) => {
  return {
    method: "POST",
    url: `/Quicksale/SaveINV06QS_Delievry`,
    data: apiObj,
  };
};

export const Order_Cancel_Api = (apiObj) => {
  return {
    method: "POST",
    url: `/Quicksale/CancelDelivery`,
    data: apiObj,
  };
};

export const getHead_VENDOR = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSInbound/getHead_VENDOR`,
    data: apiObj,
  };
};
export const searchHead_VENDOR = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSInbound/searchHead_VENDOR`,
    data: apiObj,
  };
};
export const getHead_RETURN = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSInbound/getHead_RETURN`,
    data: apiObj,
  };
};
export const searchHead_RETURN = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSInbound/searchHead_RETURN`,
    data: apiObj,
  };
};
export const getHead_OUTLET = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSInbound/getHead_OUTLET`,
    data: apiObj,
  };
};
export const searchHead_OUTLET = (apiObj) => {
  return {
    method: "POST",
    url: `/WMSInbound/searchHead_OUTLET`,
    data: apiObj,
  };
};
export const WMPOIPTItemGetRowHead = (apiObj) => {
  return {
    method: "POST",
    url: `/cyclicCount/WMPOIPTItemGetRow`,
    data: apiObj,
  };
};
export const WMPOIPTItemGetRowInner = (apiObj) => {
  return {
    method: "POST",
    url: `/cyclicCount/WMPOIPTItemGetRowInner`,
    data: apiObj,
  };
};
export const WMPOIPTItemGetAisleRow = (apiObj) => {
  return {
    method: "POST",
    url: `/cyclicCount/WMPOIPT01B_WMPOIPT00B_AISLE_GetRow`,
    data: apiObj,
  };
};
export const WMPOIPT00A_REVERSAL = (apiObj) => {
  return {
    method: "POST",
    url: `/physicalstock/WMPOIPT00A_REVERSAL`,
    data: apiObj,
  };
};
export const getPayableReceivableDropdownData = (apiObj) => {
  return {
    method: "POST",
    url: `/Master/getPayableReceivableDropdownData`,
    data: apiObj,
  };
};

export const fExecuteAPI = async (
  xAPIName,
  apiObj = {},
  loaderScreen = true
) => {
  try {
    var Data = {};
    switch (xAPIName) {
      case "Login_getUserMenus__GETROW": {
        Data = await httpRequest(Login_getUserMenus__GETROW(apiObj));
        break;
      }
      case "GET_API_WTAG_GETROW": {
        Data = await httpRequest(GET_API_WTAG_GETROW(apiObj));
        break;
      }
      case "RpDesign_getGitterColumns_GETROW": {
        Data = await httpRequest(RpDesign_getGitterColumns_GETROW(apiObj));
        break;
      }
      case "GET_API_DOC_LOADING": {
        Data = await httpRequest(GET_API_DOC_LOADING(apiObj));
        break;
      }
      case "GET_API_DOC_TYPE": {
        Data = await httpRequest(GET_API_DOC_TYPE(apiObj));
        break;
      }
      case "GET_API_UNLOADING_BAY": {
        Data = await httpRequest(GET_API_UNLOADING_BAY(apiObj));
        break;
      }
      case "GET_API_CURRENCY": {
        Data = await httpRequest(GET_API_CURRENCY(apiObj));
        break;
      }
      case "SUBKONTEN_SEARCH_GETROW": {
        Data = await httpRequest(SUBKONTEN_SEARCH_GETROW(apiObj));
        break;
      }
      case "LOCATION_SEARCH_GETROW": {
        Data = await httpRequest(LOCATION_SEARCH_GETROW(apiObj));
        break;
      }
      case "REFDOC_SEARCH_GETROW": {
        Data = await httpRequest(REFDOC_SEARCH_GETROW(apiObj));
        break;
      }
      case "REF_INBOUND_SEARCH_GETROW": {
        Data = await httpRequest(REF_INBOUND_SEARCH_GETROW(apiObj));
        break;
      }
      case "KERN_GETROW": {
        Data = await httpRequest(KERN_GETROW(apiObj));
        break;
      }
      case "SUPPLIER_GETROW": {
        Data = await httpRequest(SUPPLIER_GETROW(apiObj));
        break;
      }
      case "ITEMSEARCH_GETROW": {
        Data = await httpRequest(ITEMSEARCH_GETROW(apiObj));
        break;
      }
      case "ITEM_SEARCHFULL_GETROW": {
        Data = await httpRequest(ITEM_SEARCHFULL_GETROW(apiObj));
        break;
      }
      case "BranchList_GETROW": {
        Data = await httpRequest(BranchList_GETROW(apiObj));
        break;
      }
      case "LocationItemSearch_GETROW": {
        Data = await httpRequest(LocationItemSearch_GETROW(apiObj));
        break;
      }
      case "CustomerListSearch_GETROW": {
        Data = await httpRequest(CustomerListSearch_GETROW(apiObj));
        break;
      }
      case "ItemsAliasList_GETROW": {
        Data = await httpRequest(ItemsAliasList_GETROW(apiObj));
        break;
      }
      case "SEARCHEXACTITEM_GETROW": {
        Data = await httpRequest(SEARCHEXACTITEM_GETROW(apiObj));
        break;
      }
      case "SEARCHEXACTITEM_GETROW001": {
        Data = await httpRequest(SEARCHEXACTITEM_GETROW001(apiObj));
        break;
      }
      case "GETITEMUNITS_GETROW": {
        Data = await httpRequest(GETITEMUNITS_GETROW(apiObj), loaderScreen);
        break;
      }
      case "GETITEMUNITSINBOUND_GETROW": {
        Data = await httpRequest(
          GETITEMUNITSINBOUND_GETROW(apiObj),
          loaderScreen
        );
        break;
      }
      case "SEARCHVENDORITEM_GETROW": {
        Data = await httpRequest(SEARCHVENDORITEM_GETROW(apiObj));
        break;
      }
      case "UNITRATE_GETROW": {
        Data = await httpRequest(UNITRATE_GETROW(apiObj));
        break;
      }
      case "SEARCHITEM_GETROW": {
        Data = await httpRequest(SEARCHITEM_GETROW(apiObj));
        break;
      }
      case "SEARCHITEM001_GETROW": {
        Data = await httpRequest(SEARCHITEM001_GETROW(apiObj));
        break;
      }
      case "INBOUNDUNITRATE_GETROW": {
        Data = await httpRequest(INBOUNDUNITRATE_GETROW(apiObj));
        break;
      }
      case "Inbound_Unit_Rate_GRN": {
        Data = await httpRequest(Inbound_Unit_Rate_GRN(apiObj));
        break;
      }
      case "PARTYSEARCH001_GETROW": {
        Data = await httpRequest(PARTYSEARCH001_GETROW(apiObj));
        break;
      }
      case "LOCATIONGROUP_GETROW": {
        Data = await httpRequest(LOCATIONGROUP_GETROW(apiObj));
        break;
      }
      case "TAX_GETROW": {
        Data = await httpRequest(TAX_GETROW(apiObj));
        break;
      }
      case "WMSSI_TYPES": {
        Data = await httpRequest(WMSSI_TYPES(apiObj));
        break;
      }
      case "ITEM_UNIT_GETROW": {
        Data = await httpRequest(ITEM_UNIT_GETROW(apiObj));
        break;
      }
      case "ITEM_UNIT_INSTANTPICKING_GETROW": {
        Data = await httpRequest(ITEM_UNIT_INSTANTPICKING_GETROW(apiObj));
        break;
      }
      case "ITEM_LINE_GETROW": {
        Data = await httpRequest(ITEM_LINE_GETROW(apiObj));
        break;
      }
      case "INVTRANS_ALIAS_GETROW_001": {
        Data = await httpRequest(INVTRANS_ALIAS_GETROW_001(apiObj));
        break;
      }
      case "UNIT_RATE_GETROW": {
        Data = await httpRequest(UNIT_RATE_GETROW(apiObj));
        break;
      }
      case "LOCATION": {
        Data = await httpRequest(LOCATION(apiObj));
        break;
      }

      case "INSTANCE_PICKING_SR_NO": {
        Data = await httpRequest(INSTANCE_PICKING_SR_NO(apiObj));
        break;
      }

      case "REFDOC_INV02RCVNGSC_SEARCH_GETROW": {
        Data = await httpRequest(REFDOC_INV02RCVNGSC_SEARCH_GETROW(apiObj));
        break;
      }

      case "BIN_TRANSFER_LIST": {
        Data = await httpRequest(BIN_TRANSFER_LIST(apiObj));
        break;
      }

      case "BIN_TRANSFER_REASON": {
        Data = await httpRequest(BIN_TRANSFER_REASON());
        break;
      }

      case "BIN_TRANSFER_HeadUPDATE": {
        Data = await httpRequest(BIN_TRANSFER_HeadUPDATE(apiObj));
        break;
      }

      case "BIN_TRANSFER_REASON_GETROW": {
        Data = await httpRequest(BIN_TRANSFER_REASON_GETROW(apiObj));
        break;
      }

      case "WMBIN_GETROW": {
        Data = await httpRequest(WMBIN_GETROW(apiObj));
        break;
      }

      case "BIN_TRANSFER_CARD_ID": {
        Data = await httpRequest(BIN_TRANSFER_CARD_ID(apiObj));
        break;
      }
      case "BIN_TRANSFER_BARCODE_DETAILS": {
        Data = await httpRequest(BIN_TRANSFER_BARCODE_DETAILS(apiObj));
        break;
      }
      case "BIN_MULTI_BARCODE_DETAILS": {
        Data = await httpRequest(BIN_MULTI_BARCODE_DETAILS(apiObj));
        break;
      }
      case "BIN_MULTI_BARCODE_DETAILS_CycleCount": {
        Data = await httpRequest(BIN_MULTI_BARCODE_DETAILS_CycleCount(apiObj));
        break;
      }
      case "PHYSICALSTOCK_BARCODE_DETAILS": {
        Data = await httpRequest(PHYSICALSTOCK_BARCODE_DETAILS(apiObj));
        break;
      }
      case "GET_API_BIN_STOCK": {
        Data = await httpRequest(GET_API_BIN_STOCK(apiObj));
        break;
      }
      case "GET_API_TRANS_OUT_SRNO": {
        Data = await httpRequest(GET_API_TRANS_OUT_SRNO(apiObj));
        break;
      }
      case "GET_API_TRANS_IN_SRNO": {
        Data = await httpRequest(GET_API_TRANS_IN_SRNO(apiObj));
        break;
      }
      case "GET_API_BIN_TRANSFER_OUTUPDATE": {
        Data = await httpRequest(GET_API_BIN_TRANSFER_OUTUPDATE(apiObj));
        break;
      }
      case "GET_API_BIN_TRANSFER_DETAIL_UPDATE": {
        Data = await httpRequest(GET_API_BIN_TRANSFER_DETAIL_UPDATE(apiObj));
        break;
      }
      case "GET_API_BIN_TRANSFER_INUPDATE": {
        Data = await httpRequest(GET_API_BIN_TRANSFER_INUPDATE(apiObj));
        break;
      }
      case "GET_API_BIN_STOCK_TRANSOUT": {
        Data = await httpRequest(GET_API_BIN_STOCK_TRANSOUT(apiObj));
        break;
      }
      case "GET_API_BIN_TRANSFER_OUT_LINEITEM": {
        Data = await httpRequest(GET_API_BIN_TRANSFER_OUT_LINEITEM(apiObj));
        break;
      }
      case "GET_API_BIN_TRANSFER_IN_LINEITEM": {
        Data = await httpRequest(GET_API_BIN_TRANSFER_IN_LINEITEM(apiObj));
        break;
      }
      case "GET_API_BIN_TRANSFER_LINEITEM": {
        Data = await httpRequest(GET_API_BIN_TRANSFER_LINEITEM(apiObj));
        break;
      }
      case "GET_API_BIN_TRANSFER_OUT_DELETE": {
        Data = await httpRequest(GET_API_BIN_TRANSFER_OUT_DELETE(apiObj));
        break;
      }
      case "GET_API_BIN_TRANSFER_IN_DELETE": {
        Data = await httpRequest(GET_API_BIN_TRANSFER_IN_DELETE(apiObj));
        break;
      }
      case "GET_API_BIN_TRANSFER_DELETE": {
        Data = await httpRequest(GET_API_BIN_TRANSFER_DELETE(apiObj));
        break;
      }
      case "GET_API_BIN_TRANSFER_DETAILCOUNT": {
        Data = await httpRequest(GET_API_BIN_TRANSFER_DETAILCOUNT(apiObj));
        break;
      }
      case "GET_API_BIN_TRANSFER_POSTING": {
        Data = await httpRequest(GET_API_BIN_TRANSFER_POSTING(apiObj));
        break;
      }
      case "GET_API_READ_PARAMETER": {
        Data = await httpRequest(GET_API_READ_PARAMETER(apiObj));
        break;
      }
      case "INSTANCE_PICKING_GETROW": {
        Data = await httpRequest(INSTANCE_PICKING_GETROW(apiObj));
        break;
      }
      case "INSTANCE_PICKING_BARCODE_ITEM_SEARCH_GETROW": {
        Data = await httpRequest(
          INSTANCE_PICKING_BARCODE_ITEM_SEARCH_GETROW(apiObj)
        );
        break;
      }
      case "INSTANCE_PICKING_PKD_UPDATE_GETROW": {
        Data = await httpRequest(INSTANCE_PICKING_PKD_UPDATE_GETROW(apiObj));
        break;
      }
      case "INSTANCE_PICKING_DELETE_GETROW": {
        Data = await httpRequest(INSTANCE_PICKING_DELETE_GETROW(apiObj));
        break;
      }
      case "INSTANCE_PICKING_DETAIL_LIST_GETROW": {
        Data = await httpRequest(INSTANCE_PICKING_DETAIL_LIST_GETROW(apiObj));
        break;
      }
      case "INSTANCE_PICKING_POST_GETROW": {
        Data = await httpRequest(INSTANCE_PICKING_POST_GETROW(apiObj));
        break;
      }
      case "INSTANCE_PICKING_POST_VARIANCE_GETROW": {
        Data = await httpRequest(INSTANCE_PICKING_POST_VARIANCE_GETROW(apiObj));
        break;
      }
      case "INCENTIVEGROUP_GETROW": {
        Data = await httpRequest(INCENTIVEGROUP_GETROW(apiObj), loaderScreen);
        break;
      }
      case "SUPERVISORSLABS_GETROW": {
        Data = await httpRequest(SUPERVISORSLABS_GETROW(apiObj));
        break;
      }
      case "OTHERSLABS_GETROW": {
        Data = await httpRequest(OTHERSLABS_GETROW(apiObj));
        break;
      }
      case "SALESGROUPS_GETROW": {
        Data = await httpRequest(SALESGROUPS_GETROW(apiObj));
        break;
      }
      case "SALESGROUPSSEARCH_GETROW": {
        Data = await httpRequest(SALESGROUPSSEARCH_GETROW(apiObj));
        break;
      }
      case "SALESMAN_GETROW": {
        Data = await httpRequest(SALESMAN_GETROW(apiObj));
        break;
      }
      case "SAVESIHEAD_GETROW": {
        Data = await httpRequest(SAVESIHEAD_GETROW(apiObj));
        break;
      }
      case "SAVESIDETAIL_GETROW": {
        Data = await httpRequest(SAVESIDETAIL_GETROW(apiObj));
        break;
      }
      case "GETSIHEAD_GETROW": {
        Data = await httpRequest(GETSIHEAD_GETROW(apiObj));
        break;
      }
      case "GETSIDETAILS_GETROW": {
        Data = await httpRequest(GETSIDETAILS_GETROW(apiObj));
        break;
      }
      case "SEARCHSIHEAD_GETROW": {
        Data = await httpRequest(SEARCHSIHEAD_GETROW(apiObj));
        break;
      }
      case "DELETESIHEAD_GETROW": {
        Data = await httpRequest(DELETESIHEAD_GETROW(apiObj));
        break;
      }
      case "DELETESIDETAIL_GETROW": {
        Data = await httpRequest(DELETESIDETAIL_GETROW(apiObj));
        break;
      }
      case "TRANSPARTY_GETROW": {
        Data = await httpRequest(TRANSPARTY_GETROW(apiObj));
        break;
      }
      case "SIUSERDOCS_GETROW": {
        Data = await httpRequest(SIUSERDOCS_GETROW(apiObj));
        break;
      }
      case "APPLYTDISCOUNT_GETROW": {
        Data = await httpRequest(APPLYTDISCOUNT_GETROW(apiObj));
        break;
      }
      case "VALIDATIONHEADINFO_GETROW": {
        Data = await httpRequest(VALIDATIONHEADINFO_GETROW(apiObj));
        break;
      }
      case "VALIDATIONDETAILINFO_GETROW": {
        Data = await httpRequest(VALIDATIONDETAILINFO_GETROW(apiObj));
        break;
      }
      case "CHECKDUEDATE_GETROW": {
        Data = await httpRequest(CHECKDUEDATE_GETROW(apiObj));
        break;
      }
      case "GETITEMATTRIBUTES_GETROW": {
        Data = await httpRequest(GETITEMATTRIBUTES_GETROW(apiObj));
        break;
      }
      case "Lineitemsattributes_GETROW": {
        Data = await httpRequest(Lineitemsattributes_GETROW(apiObj));
        break;
      }
      case "GetItemAttributesPurchase_GETROW": {
        Data = await httpRequest(GetItemAttributesPurchase_GETROW(apiObj));
        break;
      }
      case "GetDemandItemQty_GETROW": {
        Data = await httpRequest(GetDemandItemQty_GETROW(apiObj));
        break;
      }
      case "PoQtyValidation_GETROW": {
        Data = await httpRequest(PoQtyValidation_GETROW(apiObj));
        break;
      }
      case "SalesReturnLineItemValidation": {
        Data = await httpRequest(SalesReturnLineItemValidation(apiObj));
        break;
      }
      case "TsrQtyValidation_GETROW": {
        Data = await httpRequest(TsrQtyValidation_GETROW(apiObj));
        break;
      }
      case "GrnRefNoValidation_GETROW": {
        Data = await httpRequest(GrnRefNoValidation_GETROW(apiObj));
        break;
      }
      case "DEFAULTDRCRACCOUNT_GETROW": {
        Data = await httpRequest(DEFAULTDRCRACCOUNT_GETROW(apiObj));
        break;
      }
      // case "OVERDUEPAYMENTCHECKING_GETROW": {
      //   Data = await httpRequest(
      //     OVERDUEPAYMENTCHECKING_GETROW(apiObj)
      //   );
      //   break;
      // }
      case "USERRIGHTS_GETROW": {
        Data = await httpRequest(USERRIGHTS_GETROW(apiObj));
        break;
      }
      case "DOCRIGHTS_GETROW": {
        Data = await httpRequest(DOCRIGHTS_GETROW(apiObj));
        break;
      }
      case "TransTaxType_GETROW": {
        Data = await httpRequest(TransTaxType_GETROW(apiObj));
        break;
      }
      case "AccountTransSearch_GETROW": {
        Data = await httpRequest(AccountTransSearch_GETROW(apiObj));
        break;
      }
      case "DefaultValue_GETROW": {
        Data = await httpRequest(DefaultValue_GETROW(apiObj));
        break;
      }
      case "CHECKCUSTOMEROVERDUE_GETROW": {
        Data = await httpRequest(CHECKCUSTOMEROVERDUE_GETROW(apiObj));
        break;
      }
      case "CHECKCRLIMIT_GETROW": {
        Data = await httpRequest(CHECKCRLIMIT_GETROW(apiObj));
        break;
      }
      case "ITEMNARRATION_GETROW": {
        Data = await httpRequest(ITEMNARRATION_GETROW(apiObj));
        break;
      }
      case "REVERSETRANSACTION_GETROW": {
        Data = await httpRequest(REVERSETRANSACTION_GETROW(apiObj));
        break;
      }
      case "DISPATCHSUMMARY_GETROW": {
        Data = await httpRequest(DISPATCHSUMMARY_GETROW(apiObj));
        break;
      }
      case "DISPATCH_GETITEMS_GETROW": {
        Data = await httpRequest(DISPATCH_GETITEMS_GETROW(apiObj));
        break;
      }
      case "DISPATCH_DELETE_ITEMS_GETROW": {
        Data = await httpRequest(DISPATCH_DELETE_ITEMS_GETROW(apiObj));
        break;
      }
      case "DISPATCH_SAVE_ITEMS_GETROW": {
        Data = await httpRequest(DISPATCH_SAVE_ITEMS_GETROW(apiObj));
        break;
      }
      case "DISPATCH_VARIANCE_ITEMS_GETROW": {
        Data = await httpRequest(DISPATCH_VARIANCE_ITEMS_GETROW(apiObj));
        break;
      }
      case "DISPATCH_POSTDISPATCH_ITEMS_GETROW": {
        Data = await httpRequest(DISPATCH_POSTDISPATCH_ITEMS_GETROW(apiObj));
        break;
      }
      case "WMSSI_ITEMSTOCK_GETROW": {
        Data = await httpRequest(WMSSI_ITEMSTOCK_GETROW(apiObj));
        break;
      }
      case "AUDITFIELD_GETROW": {
        Data = await httpRequest(AUDITFIELD_GETROW(apiObj));
        break;
      }
      case "TRANSAUDIT_GETROW": {
        Data = await httpRequest(TRANSAUDIT_GETROW(apiObj));
        break;
      }
      case "SALESHISTORY_GETROW": {
        Data = await httpRequest(SALESHISTORY_GETROW(apiObj));
        break;
      }
      case "WMTransSalesGroupDetail_GETROW": {
        Data = await httpRequest(WMTransSalesGroupDetail_GETROW(apiObj));
        break;
      }
      case "WMTransSalesGroupUpdate_GETROW": {
        Data = await httpRequest(WMTransSalesGroupUpdate_GETROW(apiObj));
        break;
      }
      case "defcustomersetting_GETROW": {
        Data = await httpRequest(defcustomersetting_GETROW(apiObj));
        break;
      }
      case "EmployeeSearchVanGroup_GETROW": {
        Data = await httpRequest(EmployeeSearchVanGroup_GETROW(apiObj));
        break;
      }
      case "WMINV08VANMastItemSave_GETROW": {
        Data = await httpRequest(WMINV08VANMastItemSave_GETROW(apiObj));
        break;
      }
      case "WMINV08VANMastItemDelete_GETROW": {
        Data = await httpRequest(WMINV08VANMastItemDelete_GETROW(apiObj));
        break;
      }
      case "WMINV08VANMastItemList_GETROW": {
        Data = await httpRequest(WMINV08VANMastItemList_GETROW(apiObj));
        break;
      }
      case "WMINV08_wmsErpStockDetail_GETROW": {
        Data = await httpRequest(WMINV08_wmsErpStockDetail_GETROW(apiObj));
        break;
      }
      case "FillVanMaster_GETROW": {
        Data = await httpRequest(FillVanMaster_GETROW(apiObj));
        break;
      }
      case "LOADING_SUMMARY_GETROW": {
        Data = await httpRequest(LOADING_SUMMARY_GETROW(apiObj));
        break;
      }
      case "EASY_LOADING_SUMMARY_GETROW": {
        Data = await httpRequest(EASY_LOADING_SUMMARY_GETROW(apiObj));
        break;
      }
      case "LOADING_ITEMSEARCH_GETROW": {
        Data = await httpRequest(LOADING_ITEMSEARCH_GETROW(apiObj));
        break;
      }
      case "LOADING_VARIANCE_GETROW": {
        Data = await httpRequest(LOADING_VARIANCE_GETROW(apiObj));
        break;
      }
      case "LOADING_VARIANCE_LDList_GETROW": {
        Data = await httpRequest(LOADING_VARIANCE_LDList_GETROW(apiObj));
        break;
      }
      case "LOADING_ITEMLIST_GETROW": {
        Data = await httpRequest(LOADING_ITEMLIST_GETROW(apiObj));
        break;
      }
      case "LOADING_ITEMDELETE_GETROW": {
        Data = await httpRequest(LOADING_ITEMDELETE_GETROW(apiObj));
        break;
      }
      case "LOADING_ITEMSAVE_GETROW": {
        Data = await httpRequest(LOADING_ITEMSAVE_GETROW(apiObj));
        break;
      }
      case "LOADING_ITEMPOST_GETROW": {
        Data = await httpRequest(LOADING_ITEMPOST_GETROW(apiObj));
        break;
      }

      case "NOTIFICATION_SUMMARY_GETROW": {
        Data = await httpRequest(NOTIFICATION_SUMMARY_GETROW(apiObj));
        break;
      }
      case "NOTIFICATION_PICKINGHEAD_GETROW": {
        Data = await httpRequest(NOTIFICATION_PICKINGHEAD_GETROW(apiObj));
        break;
      }
      case "NOTIFICATION_PICKINGAISLELIST_GETROW": {
        Data = await httpRequest(NOTIFICATION_PICKINGAISLELIST_GETROW(apiObj));
        break;
      }
      case "NOTIFICATION_PICKINGLEVELLIST_GETROW": {
        Data = await httpRequest(NOTIFICATION_PICKINGLEVELLIST_GETROW(apiObj));
        break;
      }
      case "NOTIFICATION_PICKINGPENDINGITEMS_GETROW": {
        Data = await httpRequest(
          NOTIFICATION_PICKINGPENDINGITEMS_GETROW(apiObj)
        );
        break;
      }
      case "NOTIFICATION_PICKINGSAVING_GETROW": {
        Data = await httpRequest(NOTIFICATION_PICKINGSAVING_GETROW(apiObj));
        break;
      }
      case "NOTIFICATION_PICKINGPOSTING_GETROW": {
        Data = await httpRequest(NOTIFICATION_PICKINGPOSTING_GETROW(apiObj));
        break;
      }
      case "NOTIFICATION_PICKINGVARIANCE_GETROW": {
        Data = await httpRequest(NOTIFICATION_PICKINGVARIANCE_GETROW(apiObj));
        break;
      }
      case "NOTIFICATION_PICKINGCARDIDSEARCH_GETROW": {
        Data = await httpRequest(
          NOTIFICATION_PICKINGCARDIDSEARCH_GETROW(apiObj)
        );
        break;
      }
      case "NOTIFICATION_PICKINGLINEDETAIL_GETROW": {
        Data = await httpRequest(NOTIFICATION_PICKINGLINEDETAIL_GETROW(apiObj));
        break;
      }
      case "BIN_ENQUIRY_GETROW": {
        Data = await httpRequest(BIN_ENQUIRY_GETROW(apiObj));
        break;
      }
      //new GrnAPI
      case "GRN_INV02RCVNGSCSEARCH_GETROW": {
        Data = await httpRequest(GRN_INV02RCVNGSCSEARCH_GETROW(apiObj));
        break;
      }
      case "GRN_RefSearchSearch_GETROW": {
        Data = await httpRequest(GRN_RefSearchSearch_GETROW(apiObj));
        break;
      }
      case "GRN_LOCATIONSEARCH_GETROW": {
        Data = await httpRequest(GRN_LOCATIONSEARCH_GETROW(apiObj));
        break;
      }
      case "GRN_ITEMSEARCH_GETROW": {
        Data = await httpRequest(GRN_ITEMSEARCH_GETROW(apiObj));
        break;
      }
      case "GRN_USER_DOC_GETROW_001": {
        Data = await httpRequest_001(GRN_USER_DOC_GETROW_001(apiObj));
        break;
      }
      case "GRN_SAVE_HEAD_GETROW_001": {
        Data = await httpRequest_001(GRN_SAVE_HEAD_GETROW_001(apiObj));
        break;
      }
      case "GRN_SAVE_DETAIL_GETROW_001": {
        Data = await httpRequest_001(GRN_SAVE_DETAIL_GETROW_001(apiObj));
        break;
      }
      case "GRN_GET_HEAD_GETROW_001": {
        Data = await httpRequest_001(GRN_GET_HEAD_GETROW_001(apiObj));
        break;
      }
      case "GRN_GET_DETAIL_GETROW_001": {
        Data = await httpRequest_001(GRN_GET_DETAIL_GETROW_001(apiObj));
        break;
      }
      case "GRN_DELETE_HEAD_GETROW_001": {
        Data = await httpRequest_001(GRN_DELETE_HEAD_GETROW_001(apiObj));
        break;
      }
      case "GRN_DELETE_DETAIL_GETROW_001": {
        Data = await httpRequest_001(GRN_DELETE_DETAIL_GETROW_001(apiObj));
        break;
      }
      case "SAVE_DETAIL_BATCH_GETROW_001": {
        Data = await httpRequest_001(SAVE_DETAIL_BATCH_GETROW_001(apiObj));
        break;
      }
      case "DELETE_DETAIL_BATCH_GETROW_001": {
        Data = await httpRequest_001(DELETE_DETAIL_BATCH_GETROW_001(apiObj));
        break;
      }
      case "WMINV03VANMASTFill_GETROW": {
        Data = await httpRequest(WMINV03VANMASTFill_GETROW(apiObj));
        break;
      }
      case "WMINV03VANMASTSave_GETROW": {
        Data = await httpRequest(WMINV03VANMASTSave_GETROW(apiObj));
        break;
      }
      case "Inbound_applyTDiscount_GETROW": {
        Data = await httpRequest(Inbound_applyTDiscount_GETROW(apiObj));
        break;
      }
      case "FreightUpdate_GETROW": {
        Data = await httpRequest(FreightUpdate_GETROW(apiObj));
        break;
      }
      case "WMINV03VANMASTDelete_GETROW": {
        Data = await httpRequest(WMINV03VANMASTDelete_GETROW(apiObj));
        break;
      }
      case "WMINV03VANMASTDetail_GETROW": {
        Data = await httpRequest(WMINV03VANMASTDetail_GETROW(apiObj));
        break;
      }
      case "searchHead_GETROW": {
        Data = await httpRequest(searchHead_GETROW(apiObj));
        break;
      }
      case "VALIDATE_HEAD_WMINV03_GETROW": {
        Data = await httpRequest(VALIDATE_HEAD_WMINV03_GETROW(apiObj));
        break;
      }
      case "CHECK_PO_CREDIT_NOTE_AMOUNT_GETROW": {
        Data = await httpRequest(CHECK_PO_CREDIT_NOTE_AMOUNT_GETROW(apiObj));
        break;
      }
      case "VALIDATE_COST_VARIANCE_GETROW": {
        Data = await httpRequest(VALIDATE_COST_VARIANCE_GETROW(apiObj));
        break;
      }
      case "GET_BATCH_DETAILS_GETROW_001": {
        Data = await httpRequest_001(GET_BATCH_DETAILS_GETROW_001(apiObj));
        break;
      }
      case "GET_getVirtualBinList_GETROW": {
        Data = await httpRequest(GET_getVirtualBinList_GETROW(apiObj));
        break;
      }
      case "GRN_BUYER_GETROW_001": {
        Data = await httpRequest_001(GRN_BUYER_GETROW_001(apiObj));
        break;
      }
      case "Checkbox_User_Rights_GETROW": {
        Data = await httpRequest(Checkbox_User_Rights_GETROW(apiObj));
        break;
      }
      case "WMINV03D_GetRow": {
        Data = await httpRequest(WMINV03D_GetRow(apiObj));
        break;
      }
      case "WMINV03_CostUpdate_GETROW": {
        Data = await httpRequest(WMINV03_CostUpdate_GETROW(apiObj));
        break;
      }
      //WMINV04 outbound Grv
      case "WMINV04_getTypes_GETROW": {
        Data = await httpRequest(WMINV04_getTypes_GETROW(apiObj));
        break;
      }
      case "WMINV04_saveHead_GETROW": {
        Data = await httpRequest(WMINV04_saveHead_GETROW(apiObj));
        break;
      }
      case "WMINV04_saveDetail_GETROW": {
        Data = await httpRequest(WMINV04_saveDetail_GETROW(apiObj));
        break;
      }
      case "WMINV04_getHead_GETROW": {
        Data = await httpRequest(WMINV04_getHead_GETROW(apiObj));
        break;
      }
      case "WMINV04_getDetails_GETROW": {
        Data = await httpRequest(WMINV04_getDetails_GETROW(apiObj));
        break;
      }
      case "WMINV04_search_GETROW": {
        Data = await httpRequest(WMINV04_search_GETROW(apiObj));
        break;
      }
      case "WMINV04_deleteHead_GETROW": {
        Data = await httpRequest(WMINV04_deleteHead_GETROW(apiObj));
        break;
      }
      case "WMINV04_deleteDetail_GETROW": {
        Data = await httpRequest(WMINV04_deleteDetail_GETROW(apiObj));
        break;
      }
      case "WMINV04_getUserDocs_GETROW": {
        Data = await httpRequest(WMINV04_getUserDocs_GETROW(apiObj));
        break;
      }
      case "WMINV04_applyTDiscount_GETROW": {
        Data = await httpRequest(WMINV04_applyTDiscount_GETROW(apiObj));
        break;
      }
      case "WMINV04_itemStock_GETROW": {
        Data = await httpRequest(WMINV04_itemStock_GETROW(apiObj));
        break;
      }
      case "WMINV04_salesHistory_GETROW": {
        Data = await httpRequest(WMINV04_salesHistory_GETROW(apiObj));
        break;
      }
      case "WMINV04_validateHead_GETROW": {
        Data = await httpRequest(WMINV04_validateHead_GETROW(apiObj));
        break;
      }
      case "WMINV04_validateDetail_GETROW": {
        Data = await httpRequest(WMINV04_validateDetail_GETROW(apiObj));
        break;
      }
      case "WMINV04_reverseTransaction_GETROW": {
        Data = await httpRequest(WMINV04_reverseTransaction_GETROW(apiObj));
        break;
      }
      case "WMINV04_getItemAttributesPurchaseReturn_GETROW": {
        Data = await httpRequest(
          WMINV04_getItemAttributesPurchaseReturn_GETROW(apiObj)
        );
        break;
      }
      case "LoadingList_Cluster_GETROW": {
        Data = await httpRequest(LoadingList_Cluster_GETROW(apiObj));
        break;
      }
      case "LoadingList_Location_GETROW": {
        Data = await httpRequest(LoadingList_Location_GETROW(apiObj));
        break;
      }
      case "LoadingList_Transaction_GETROW": {
        Data = await httpRequest(LoadingList_Transaction_GETROW(apiObj));
        break;
      }
      case "LoadingList_LoadingPay_GETROW": {
        Data = await httpRequest(LoadingList_LoadingPay_GETROW(apiObj));
        break;
      }
      case "LoadingList_Truck_GETROW": {
        Data = await httpRequest(LoadingList_Truck_GETROW(apiObj));
        break;
      }
      case "LoadingList_LoadingType_GETROW": {
        Data = await httpRequest(LoadingList_LoadingType_GETROW(apiObj));
        break;
      }
      case "LoadingList_loadinglistcheckbox_GETROW": {
        Data = await httpRequest(
          LoadingList_loadinglistcheckbox_GETROW(apiObj)
        );
        break;
      }
      case "LoadingList_GridLoad_GETROW": {
        Data = await httpRequest(LoadingList_GridLoad_GETROW(apiObj));
        break;
      }
      case "LoadingList_TransDetail_GETROW": {
        Data = await httpRequest(LoadingList_TransDetail_GETROW(apiObj));
        break;
      }
      case "LoadingList_FupdateHead_GETROW": {
        Data = await httpRequest(LoadingList_FupdateHead_GETROW(apiObj));
        break;
      }
      case "LoadingList_Release_GETROW": {
        Data = await httpRequest(LoadingList_Release_GETROW(apiObj));
        break;
      }
      case "LoadingList_getHead_GETROW": {
        Data = await httpRequest(LoadingList_getHead_GETROW(apiObj));
        break;
      }
      case "LoadingList_save_detail_GETROW": {
        Data = await httpRequest(LoadingList_save_detail_GETROW(apiObj));
        break;
      }
      case "LoadingList_deleteHead_GETROW": {
        Data = await httpRequest(LoadingList_deleteHead_GETROW(apiObj));
        break;
      }
      case "LoadingList_getUserDocs_GETROW": {
        Data = await httpRequest(LoadingList_getUserDocs_GETROW(apiObj));
        break;
      }
      case "LoadingList_Reverse_GETROW": {
        Data = await httpRequest(LoadingList_Reverse_GETROW(apiObj));
        break;
      }
      case "LoadingList_LoadingSearch_GETROW": {
        Data = await httpRequest(LoadingList_LoadingSearch_GETROW(apiObj));
        break;
      }
      case "LoadingReceipt_Location_GETROW": {
        Data = await httpRequest(LoadingReceipt_Location_GETROW(apiObj));
        break;
      }
      case "LoadingReceipt_LoadGrid_GETROW": {
        Data = await httpRequest(LoadingReceipt_LoadGrid_GETROW(apiObj));
        break;
      }
      case "LoadingReceipt_SaveDetails_GETROW": {
        Data = await httpRequest(LoadingReceipt_SaveDetails_GETROW(apiObj));
        break;
      }
      case "LoadingReceipt_DeleteDetails_GETROW": {
        Data = await httpRequest(LoadingReceipt_DeleteDetails_GETROW(apiObj));
        break;
      }
      case "LoadingReceipt_fDisplay_GETROW": {
        Data = await httpRequest(LoadingReceipt_fDisplay_GETROW(apiObj));
        break;
      }
      case "LoadingReceipt_Search_GETROW": {
        Data = await httpRequest(LoadingReceipt_Search_GETROW(apiObj));
        break;
      }
      case "LoadingReceipt_UserDoc_GETROW": {
        Data = await httpRequest(LoadingReceipt_UserDoc_GETROW(apiObj));
        break;
      }
      case "LoadingReceipt_Approve_GETROW": {
        Data = await httpRequest(LoadingReceipt_Approve_GETROW(apiObj));
        break;
      }
      case "LoadingReceipt_DoStamping_GETROW": {
        Data = await httpRequest(LoadingReceipt_DoStamping_GETROW(apiObj));
        break;
      }
      case "LoadingReceipt_StampingUpdate_GETROW": {
        Data = await httpRequest(LoadingReceipt_StampingUpdate_GETROW(apiObj));
        break;
      }
      case "WMINV10_saveHead_GETROW": {
        Data = await httpRequest(WMINV10_saveHead_GETROW(apiObj));
        break;
      }
      case "WMINV10_fDisplay_GETROW": {
        Data = await httpRequest(WMINV10_fDisplay_GETROW(apiObj));
        break;
      }
      case "WMINV10_deleteHead_GETROW": {
        Data = await httpRequest(WMINV10_deleteHead_GETROW(apiObj));
        break;
      }
      case "WMINV10_saveDetail_GETROW": {
        Data = await httpRequest(WMINV10_saveDetail_GETROW(apiObj));
        break;
      }
      case "WMINV10_deleteDetails_GETROW": {
        Data = await httpRequest(WMINV10_deleteDetails_GETROW(apiObj));
        break;
      }
      case "WMINV10_GridLoad_GETROW": {
        Data = await httpRequest(WMINV10_GridLoad_GETROW(apiObj));
        break;
      }
      case "WMINV10_userDoc_GETROW": {
        Data = await httpRequest(WMINV10_userDoc_GETROW(apiObj));
        break;
      }
      case "WMINV10_Search_GETROW": {
        Data = await httpRequest(WMINV10_Search_GETROW(apiObj));
        break;
      }
      case "WMINV10_SearchLocation_GETROW": {
        Data = await httpRequest(WMINV10_SearchLocation_GETROW(apiObj));
        break;
      }
      case "WMINV10_Location_GETROW": {
        Data = await httpRequest(WMINV10_Location_GETROW(apiObj));
        break;
      }
      case "WMINV10_Party_GETROW": {
        Data = await httpRequest(WMINV10_Party_GETROW(apiObj));
        break;
      }
      case "WMINV10_itemUnit_GETROW": {
        Data = await httpRequest(WMINV10_itemUnit_GETROW(apiObj));
        break;
      }
      case "WMINV10_UnitRate_GETROW": {
        Data = await httpRequest(WMINV10_UnitRate_GETROW(apiObj));
        break;
      }
      case "WMINV10_getItemAttributesPurchaseReturn_GETROW": {
        Data = await httpRequest(
          WMINV10_getItemAttributesPurchaseReturn_GETROW(apiObj)
        );
        break;
      }
      case "WMINV10_validatecostvariance_GETROW": {
        Data = await httpRequest(WMINV10_validatecostvariance_GETROW(apiObj));
        break;
      }
      case "WMINV10_validateDetail_GETROW": {
        Data = await httpRequest(WMINV10_validateDetail_GETROW(apiObj));
        break;
      }
      case "WMINV10_validateHead_GETROW": {
        Data = await httpRequest(WMINV10_validateHead_GETROW(apiObj));
        break;
      }
      case "WMINV10_reverseTransaction_GETROW": {
        Data = await httpRequest(WMINV10_reverseTransaction_GETROW(apiObj));
        break;
      }
      case "WMINV11_history_GETROW": {
        Data = await httpRequest(WMINV11_history_GETROW(apiObj));
        break;
      }
      case "WMINV11_UnitRate_GETROW": {
        Data = await httpRequest(WMINV11_UnitRate_GETROW(apiObj));
        break;
      }
      case "WMINV11_reason_GETROW": {
        Data = await httpRequest(WMINV11_reason_GETROW(apiObj));
        break;
      }
      case "WMINV11_adjustmentType_GETROW": {
        Data = await httpRequest(WMINV11_adjustmentType_GETROW(apiObj));
        break;
      }
      case "WMINV11_location_GETROW": {
        Data = await httpRequest(WMINV11_location_GETROW(apiObj));
        break;
      }
      case "WMINV11_saveHead_GETROW": {
        Data = await httpRequest(WMINV11_saveHead_GETROW(apiObj));
        break;
      }
      case "WMINV11_saveDetail_GETROW": {
        Data = await httpRequest(WMINV11_saveDetail_GETROW(apiObj));
        break;
      }
      case "WMINV11_deleteHead_GETROW": {
        Data = await httpRequest(WMINV11_deleteHead_GETROW(apiObj));
        break;
      }
      case "WMINV11_deleteDetail_GETROW": {
        Data = await httpRequest(WMINV11_deleteDetail_GETROW(apiObj));
        break;
      }
      case "WMINV11_fdisplay_GETROW": {
        Data = await httpRequest(WMINV11_fdisplay_GETROW(apiObj));
        break;
      }
      case "WMINV11_search_GETROW": {
        Data = await httpRequest(WMINV11_search_GETROW(apiObj));
        break;
      }
      case "WMINV11_gridLoad_GETROW": {
        Data = await httpRequest(WMINV11_gridLoad_GETROW(apiObj));
        break;
      }
      case "WMINV11_userDoc_GETROW": {
        Data = await httpRequest(WMINV11_userDoc_GETROW(apiObj));
        break;
      }
      case "WMINV11_currentStock_GETROW": {
        Data = await httpRequest(WMINV11_currentStock_GETROW(apiObj));
        break;
      }
      case "WMINV11_validateHead_GETROW": {
        Data = await httpRequest(WMINV11_validateHead_GETROW(apiObj));
        break;
      }
      case "WMINV11_validateDetail_GETROW": {
        Data = await httpRequest(WMINV11_validateDetail_GETROW(apiObj));
        break;
      }
      case "WMINV11_getItemAttributes_GETROW": {
        Data = await httpRequest(WMINV11_getItemAttributes_GETROW(apiObj));
        break;
      }
      case "INV08_savehead_GETROW": {
        Data = await httpRequest(INV08_savehead_GETROW(apiObj));
        break;
      }
      case "INV08_history_GETROW": {
        Data = await httpRequest(INV08_history_GETROW(apiObj));
        break;
      }
      case "INV08_saveDetail_GETROW": {
        Data = await httpRequest(INV08_saveDetail_GETROW(apiObj));
        break;
      }
      case "INV08_deleteHead_GETROW": {
        Data = await httpRequest(INV08_deleteHead_GETROW(apiObj));
        break;
      }
      case "INV08_deleteDetail_GETROW": {
        Data = await httpRequest(INV08_deleteDetail_GETROW(apiObj));
        break;
      }
      case "INV08_search_GETROW": {
        Data = await httpRequest(INV08_search_GETROW(apiObj));
        break;
      }
      case "INV08_audit_GETROW": {
        Data = await httpRequest(INV08_audit_GETROW(apiObj));
        break;
      }
      case "INV08_fDisplay_GETROW": {
        Data = await httpRequest(INV08_fDisplay_GETROW(apiObj));
        break;
      }
      case "INV08_loadGrid_GETROW": {
        Data = await httpRequest(INV08_loadGrid_GETROW(apiObj));
        break;
      }
      case "INV08_userDoc_GETROW": {
        Data = await httpRequest(INV08_userDoc_GETROW(apiObj));
        break;
      }
      case "WMIPT01_gridLoad_GETROW": {
        Data = await httpRequest(WMIPT01_gridLoad_GETROW(apiObj));
        break;
      }
      case "WMIPT01_saveHead_GETROW": {
        Data = await httpRequest(WMIPT01_saveHead_GETROW(apiObj));
        break;
      }
      case "WMIPT01_saveDetail_GETROW": {
        Data = await httpRequest(WMIPT01_saveDetail_GETROW(apiObj));
        break;
      }
      case "WMIPT01_deleteHead_GETROW": {
        Data = await httpRequest(WMIPT01_deleteHead_GETROW(apiObj));
        break;
      }
      case "WMIPT01_deleteDetail_GETROW": {
        Data = await httpRequest(WMIPT01_deleteDetail_GETROW(apiObj));
        break;
      }
      case "WMIPT01_summary_GETROW": {
        Data = await httpRequest(WMIPT01_summary_GETROW(apiObj));
        break;
      }
      case "WMPOIPT01_poGridLoad_GETROW": {
        Data = await httpRequest(WMPOIPT01_poGridLoad_GETROW(apiObj));
        break;
      }
      case "WMPOIPT01_poSaveHead_GETROW": {
        Data = await httpRequest(WMPOIPT01_poSaveHead_GETROW(apiObj));
        break;
      }
      case "WMPOIPT01_poSaveDetail_GETROW": {
        Data = await httpRequest(WMPOIPT01_poSaveDetail_GETROW(apiObj));
        break;
      }
      case "WMPOIPT01_poDelete_GETROW": {
        Data = await httpRequest(WMPOIPT01_poDelete_GETROW(apiObj));
        break;
      }
      case "WMPOIPT01_poDisplay_GETROW": {
        Data = await httpRequest(WMPOIPT01_poDisplay_GETROW(apiObj));
        break;
      }
      case "WMPOIPT01_poSummary_GETROW": {
        Data = await httpRequest(WMPOIPT01_poSummary_GETROW(apiObj));
        break;
      }
      case "WMPOIPT01_poApprove_GETROW": {
        Data = await httpRequest(WMPOIPT01_poApprove_GETROW(apiObj));
        break;
      }
      case "WMPOIPT01_PoType_GETROW": {
        Data = await httpRequest(WMPOIPT01_PoType_GETROW(apiObj));
        break;
      }
      case "PUTAWAY_getPutAwaySummary_GETROW": {
        Data = await httpRequest(PUTAWAY_getPutAwaySummary_GETROW(apiObj));
        break;
      }
      case "PUTAWAY_putAwayBiny_GETROW": {
        Data = await httpRequest(PUTAWAY_putAwayBiny_GETROW(apiObj));
        break;
      }
      case "PUTAWAY_putAwayVariance_GETROW": {
        Data = await httpRequest(PUTAWAY_putAwayVariance_GETROW(apiObj));
        break;
      }
      case "PUTAWAY_getPutAwayHead_GETROW": {
        Data = await httpRequest(PUTAWAY_getPutAwayHead_GETROW(apiObj));
        break;
      }
      case "PUTAWAY_savePutAway_GETROW": {
        Data = await httpRequest(PUTAWAY_savePutAway_GETROW(apiObj));
        break;
      }
      case "PUTAWAY_deteteItem_GETROW": {
        Data = await httpRequest(PUTAWAY_deteteItem_GETROW(apiObj));
        break;
      }
      case "PUTAWAY_loadDetail_GETROW": {
        Data = await httpRequest(PUTAWAY_loadDetail_GETROW(apiObj));
        break;
      }
      case "PUTAWAY_checkPutawayCompleted_GETROW": {
        Data = await httpRequest(PUTAWAY_checkPutawayCompleted_GETROW(apiObj));
        break;
      }
      case "PUTAWAY_approvePutAway_GETROW": {
        Data = await httpRequest(PUTAWAY_approvePutAway_GETROW(apiObj));
        break;
      }
      case "PUTAWAY_getCardDetail_GETROW": {
        Data = await httpRequest(PUTAWAY_getCardDetail_GETROW(apiObj));
        break;
      }
      case "PUTAWAY_putAwayBarcode_GETROW": {
        Data = await httpRequest(PUTAWAY_putAwayBarcode_GETROW(apiObj));
        break;
      }
      case "PUTAWAY_validateDetails_GETROW": {
        Data = await httpRequest(PUTAWAY_validateDetails_GETROW(apiObj));
        break;
      }
      case "PUTAWAY_validateDetails_GETROW_EasyPutaway": {
        Data = await httpRequest(
          PUTAWAY_validateDetails_GETROW_EasyPutaway(apiObj)
        );
        break;
      }
      case "Common_transpartylist_GETROW": {
        Data = await httpRequest(Common_transpartylist_GETROW(apiObj));
        break;
      }
      case "Common_partyosamtt_GETROW": {
        Data = await httpRequest(Common_partyosamtt_GETROW(apiObj));
        break;
      }
      case "Quicksale_SaveINV06QS": {
        Data = await httpRequest(Quicksale_SaveINV06QS(apiObj));
        break;
      }
      case "getHead_VENDOR": {
        Data = await httpRequest_001(getHead_VENDOR(apiObj));
        break;
      }
      case "searchHead_VENDOR": {
        Data = await httpRequest_001(searchHead_VENDOR(apiObj));
        break;
      }
      case "getHead_RETURN": {
        Data = await httpRequest_001(getHead_RETURN(apiObj));
        break;
      }
      case "searchHead_RETURN": {
        Data = await httpRequest_001(searchHead_RETURN(apiObj));
        break;
      }
      case "getHead_OUTLET": {
        Data = await httpRequest_001(getHead_OUTLET(apiObj));
        break;
      }
      case "searchHead_OUTLET": {
        Data = await httpRequest_001(searchHead_OUTLET(apiObj));
        break;
      }
      case "WMPOIPTItemGetRowHead": {
        Data = await httpRequest_001(WMPOIPTItemGetRowHead(apiObj));
        break;
      }
      case "WMPOIPTItemGetRowInner": {
        Data = await httpRequest_001(WMPOIPTItemGetRowInner(apiObj));
        break;
      }
      case "WMPOIPTItemGetAisleRow": {
        Data = await httpRequest_001(WMPOIPTItemGetAisleRow(apiObj));
        break;
      }
      case "WMPOIPT00A_REVERSAL": {
        Data = await httpRequest(WMPOIPT00A_REVERSAL(apiObj));
        break;
      }
      case "getPayableReceivableDropdownData": {
        Data = await httpRequest(getPayableReceivableDropdownData(apiObj));
        break;
      }
      default:
        break;
    }
    if (Data?.Type?.toUpperCase() === "FAILED") {
      return Data;
    } else if (Data?.Type?.toUpperCase() === "SUCCESS") {
      return Data;
    } else {
      return Data;
    }
  } catch (err) {
    return err;
  }
};
